import { combineReducers } from 'redux';
import { employeeType } from './employeeType/reducer';
import { departments } from './department/reducer';

export const employment = combineReducers({
    employeeType,
    departments,
});
